import React from 'react';
import { t } from '../../translation';
import '../../style.scss';

interface QualitySelectorProps {
  className?: string;
}

/**
 * Componente para seleccionar la calidad de renderizado
 */
const QualitySelector: React.FC<QualitySelectorProps> = ({ className = '' }) => {
  const [quality, setQuality] = React.useState('1.5');

  const handleQualityChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const value = e.target.value;
    setQuality(value);
    
    // Actualizar el pixel scale en el viewer si está disponible
    if (window.viewer) {
      window.viewer.observer.set('camera.pixelScale', parseFloat(value));
    }
  };

  return (
    <div className={`quality-selector ${className}`}>
      <label htmlFor="quality-select">{t('camera.quality')}: </label>
      <select 
        id="quality-select"
        value={quality}
        onChange={handleQualityChange}
        className="quality-select"
      >
        <option value={'0.5'}>HD</option>
        <option value={'2'}>SD</option>
      </select>
    </div>
  );
};

export default QualitySelector;
